/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Error_SpeechInputs */



/**
* | output |
* | --- |
* | "The spoken reply could not be generated. The written answer is in the chat." |
*
* @param {Voice_Error_SpeechInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const voice_error_speech = /** @type {((inputs?: Voice_Error_SpeechInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Error_SpeechInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die gesprochene Antwort konnte nicht erzeugt werden. Die schriftliche Antwort steht im Chat.")
	return /** @type {LocalizedString} */ ("The spoken reply could not be generated. The written answer is in the chat.")
});